module.exports = __webpack_public_path__ + "b4b74bd55cc4bd6a85fc390ac0bcea4a.MP3";